<header class="fixed top-0 z-[101] w-full" [ngClass]="config.classes">
<!--<header class="bg-surface fixed top-0 z-[101] w-full" [ngClass]="config.classes">-->
  <div class="h-full flex flex-row items-center px-6">
    <ng-container *ngIf="!titleRef; else useRef">
      <h1 *ngIf="config.title" class="app-title" [routerLink]="'/'">{{config.title}}</h1>
    </ng-container>
    <ng-template #useRef>
      <ng-container *ngTemplateOutlet="titleRef"></ng-container>
    </ng-template>
  </div>
</header>
